document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const header = document.querySelector('[data-header]');
  if (toggle && header) toggle.addEventListener('click', () => header.classList.toggle('nav-open'));

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variants = JSON.parse(form.querySelector('[data-variants-json]')?.textContent || '[]');
    const idInput = form.querySelector('input[name="id"]');
    const price = form.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-to-cart]');
    const optionInputs = [...form.querySelectorAll('[data-option-input]')];

    const money = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency: window.Shopify?.currency?.active || 'USD'}).format(cents/100); }
      catch(e) { return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = () => {
      const selected = [];
      const positions = [...new Set(optionInputs.map(i => i.dataset.optionPosition))];
      positions.forEach(pos => {
        const checked = form.querySelector(`[data-option-position="${pos}"]:checked`);
        selected.push(checked ? checked.value : null);
      });
      const match = variants.find(v => selected.every((value, idx) => !value || v.options[idx] === value));
      if (!match) {
        idInput.value = '';
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      if (price) price.textContent = money(match.price);
      button.disabled = !match.available;
      button.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${match.id}`);
    };

    optionInputs.forEach(input => input.addEventListener('change', updateVariant));
    updateVariant();
  });
});
